import { Theme, createStyles } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    height: '100vh',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
  },
  detailsPanel: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  detailsPanelPaper: {
    display: 'flex',
    flex: 1,
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
    },
    overflow: 'scroll',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  fabButton: {
    position: 'absolute',
    right: theme.spacing(4),
    cursor: 'pointer',
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
});

export default styles;
